// api/socialMedia.js
// All social media related API functions in one place

import { get, post, globalPut } from '../index';

// Get OAuth authorization URL for a platform
// export const connectSocialMedia = (platform) => {
//   return get(`/social/${platform}/auth-url`);
// };


export const connectSocialMedia = (platform, opts = {}) => {
  const p = String(platform || '').toLowerCase();
  const q = new URLSearchParams(
    Object.entries(opts).filter(([,v]) => v != null && v !== '')
  ).toString();
  const suffix = q ? `?${q}` : '';
  return get(`/social/${p}/auth-url${suffix}`); // -> { url }
};



// Disconnect a social media platform from a specific brand. Server requires
// brandId or brandSettingsId to find the right SocialAccount — sending no
// body would be ambiguous when the same platform is connected to multiple
// brands.
export const disconnectSocialMedia = (platform, body = {}) => {
  return post(`/social/${platform}/disconnect`, body);
};

// Get connect data by connectId (after OAuth callback)
export const getSocialConnectData = (connectId) => {
  return get(`/social/connect/${connectId}`);
};

// Get social account details by ID
export const getSocialAccount = (accountId) => {
  return get(`/social/account/${accountId}`);
};

// Get targets/pages for a social account
export const getSocialAccountTargets = (accountId) => {
  return get(`/social/account/${accountId}/targets`);
};

// Save selected target/page for publishing
export const saveSocialTarget = (accountId, data) => {
  return globalPut(`/social/account/${accountId}/target`, data, false);
};

// Refresh OAuth token for a platform
export const refreshSocialToken = (platform, refreshToken) => {
  return post(`/social/${platform}/refresh`, { refreshToken });
};

// Get error details by errorId
export const getSocialError = (errorId) => {
  return get(`/social/error/${errorId}`);
};

// Get all social accounts for current user/company
export const getAllSocialAccounts = () => {
  return get('/social/accounts');
};

// Get social accounts by brand ID
export const getSocialAccountsByBrand = (brandId) => {
  return get(`/social/accounts/brand/${brandId}`);
};

// Get social accounts by company ID
export const getSocialAccountsByCompany = (companyId) => {
  return get(`/social/accounts/company/${companyId}`);
};

// Delete a social account
export const deleteSocialAccount = (accountId) => {
  return post(`/social/account/${accountId}/delete`, {});
};

// Update social account settings
export const updateSocialAccount = (accountId, data) => {
  return globalPut(`/social/account/${accountId}`, data, false);
};

// Link social account to brand
export const linkSocialAccountToBrand = (accountId, brandId) => {
  return post(`/social/account/${accountId}/link-brand`, { brandId });
};

// Unlink social account from brand
export const unlinkSocialAccountFromBrand = (accountId) => {
  return post(`/social/account/${accountId}/unlink-brand`, {});
};

// Test social account connection
export const testSocialConnection = (accountId) => {
  return get(`/social/account/${accountId}/test`);
};

// Get available platforms
export const getAvailablePlatforms = () => {
  return get('/social/platforms');
};

// Get platform-specific settings/requirements
export const getPlatformSettings = (platform) => {
  return get(`/social/platform/${platform}/settings`);
};

// Save/select the default publishing target for an account (persists on server)
export const setDefaultSocialTarget = (accountId, {
  platform,
  targetId,
  targetType,
  name,
  adsAccountId,
  token,          // optional; only if your server expects it
} = {}) => {
  return globalPut(
    `/social/account/${accountId}/target`,
    {
      platform,
      targetId,
      targetType,
      name,
      adsAccountId: adsAccountId || null,
      token: token || null,
    },
    false
  );
};